export const checkUserTreeNodeType = (type: string) => {
  if (
    type === 'RootUser' ||
    type === 'TManagementCompanyUser' ||
    type === 'THomeUser' ||
    type === 'TEntranceUser' ||
    type === 'TFlatUser' ||
    type === 'THostUser'
  )
    return true;

  return false;
};
